const ranchos = [
  {
    name: "Cambira-PR",
    prosa: { day: "Toda segunda", time: "20h", address: "Rua Paraiba, 80" },
    contact: {
      tel: "+5543998200290",
      label: "(43) 99820-0290",
      name: "Diretor – Luizão",
      photo: "/images/luiz.webp",
    },
  },
  {
    name: "Mandaguari-PR",
    prosa: {
      day: "Toda terça",
      time: "20h",
      address: "Rua Arlindo Gabriel da Silva, 8 - Popular 1",
    },
    contact: {
      tel: "+5544988482548",
      label: "(44) 98848-2548",
      name: "Rep. - Pr. Vital",
      photo: "https://d2er8q8v25uk9z.cloudfront.net/vital.webp",
    },
  },
  {
    name: "Medianeira-PR",
    contact: {
      tel: "+5545999651117",
      label: "(45) 99965-1117",
      name: "Diretor – Pr Júnior",
      photo: "https://d2er8q8v25uk9z.cloudfront.net/pjjr_uyigpzkgob.webp",
    },
    prosa: {
      day: "Toda terça",
      time: "20h",
      address: "",
    },
  },
  {
    name: "Arapongas-PR",
    contact: {
      tel: "+5543999039452",
      label: "(43) 99903-9452",
      name: "Rep. -  Júnior",
      photo: "https://d2er8q8v25uk9z.cloudfront.net/juniorquadrado.webp",
    },
    prosa: {
      day: "Toda quinta",
      time: "20h",
      address: "",
    },
  },
  {
    name: "Apucarana-PR",
    contact: {
      tel: "+5543996424555",
      label: "(43) 99642-4555",
      name: "Diretor – Robert",
      photo: "https://d2er8q8v25uk9z.cloudfront.net/robert.webp",
    },
  },
  {
    name: "São José dos Pinhais - PR",
    contact: {
      tel: "+5541991170055",
      label: "(41) 99117-0055",
      name: "Rep. -  Pr Daniel",
      photo: "https://d2er8q8v25uk9z.cloudfront.net/daniel.webp",
    },
  },
  {
    name: "Guarulhos-SP",
    contact: {
      tel: "+5511915503938",
      label: "(11) 91550-3938",
      name: "Rep. -  Bia",
      photo: "https://d2er8q8v25uk9z.cloudfront.net/bia.webp",
    },
  },
  {
    name: "Jaguariaíva-PR",
    contact: {
      tel: "+5543996418396",
      label: "(43) 99641-8396",
      name: "Rep. -  Pr. Garret",
      photo: "https://d2er8q8v25uk9z.cloudfront.net/garret.webp",
    },
  },
  {
    name: "Faxinal-PR",
    contact: {
      tel: "+5543998294939",
      label: "(43) 99829-4939",
      name: "Rep. -  Marcos",
      photo: "https://d2er8q8v25uk9z.cloudfront.net/faxinal.webp",
    },
  },
  {
    name: "Londrina-PR",
    contact: {
      tel: "+5543999812887",
      label: "(43) 99981-2887",
      name: "Rep. -  Wilson Kaba",
      photo: "https://d2er8q8v25uk9z.cloudfront.net/kaba1.webp",
    },
  },
  {
    name: "Asunción (Paraguay)",
    contact: {
      tel: "+595981242256",
      label: "+595 981 242256",
      name: "Rep. -  Mario Ayala",
      photo: "https://d2er8q8v25uk9z.cloudfront.net/paraguay.webp",
    },
  },
  {
    name: "Maringá-PR",
    contact: {
      tel: "+5544997511100",
      name: "Rep. - Ademir Kunkel",
      label: "(44) 99751-1100",
      photo: "https://d2er8q8v25uk9z.cloudfront.net/kunkel.webp",
    },
  },
  {
    name: "Campo Mourão-PR",
    contact: {
      tel: "+5543991143393",
      name: "Rep. - Pr. Maurício",
      label: "(43) 99114-3393",
      photo: "https://d2er8q8v25uk9z.cloudfront.net/mauricio.webp",
    },
  },
  {
    name: "Volta Redonda-RJ",
    contact: {
      tel: "+5524998359993",
      label: "(24) 99835-9993",
      name: "Rep. - Ottoni",
      photo: "/images/ottoni.webp",
    },
  },
  {
    name: "Foz do Iguaçu-PR",
    contact: {
      tel: "+5545991569460",
      label: "(45) 99156-9460",
      name: "Rep. - Deibity",
      photo: "/images/deibity.webp",
    },
  },
];

export default ranchos;
